const colorSystems = {
    rgb: {
        linear: {
            name: "Color System - RGB | Linear",
            description: "",
            breakpoints: [],
            borderRadius: [],
            fonts: {},
            lineHeights: {},
            colors: {
                "overlay-tint": [
                    "hsla(0, 0%, 100%, .035)",
                    "hsla(0, 0%, 100%, 0.1)",
                    "hsla(0, 0%, 100%, 0.19)",
                    "hsla(0, 0%, 100%, .28)",
                    "hsla(0, 0%, 100%, 0.36)",
                    "hsla(0, 0%, 100%, 0.45)",
                    "hsla(0, 0%, 100%, .55)",
                    "hsla(0, 0%, 100%, 0.64)",
                    "hsla(0, 0%, 100%, .73)",
                    "hsla(0, 0%, 100%, .815)",
                    "hsla(0, 0%, 100%, .895)",
                    "hsla(0, 0%, 100%, .94)",
                ],
                "overlay-shadow": [
                    "hsla(0, 0%, 0%, 0.94)",
                    "hsla(0, 0%, 0%, .895)",
                    "hsla(0, 0%, 0%, .815)",
                    "hsla(0, 0%, 0%, .73)",
                    "hsla(0, 0%, 0%, .64)",
                    "hsla(0, 0%, 0%, .55)",
                    "hsla(0, 0%, 0%, 0.45)",
                    "hsla(0, 0%, 0%, 0.36)",
                    "hsla(0, 0%, 0%, .28)",
                    "hsla(0, 0%, 0%, .19)",
                    "hsla(0, 0%, 0%, 0.1)",
                    "hsla(0, 0%, 0%, 0.035)",
                ],
                gray: [
                    "#000000",
                    "#171717",
                    "#2f2f2f",
                    "#464646",
                    "#5e5e5e",
                    "#757575",
                    "#8c8c8c",
                    "#a3a3a3",
                    "#bababa",
                    "#d1d1d1",
                    "#e8e8e8",
                    "#ffffff",
                ],
                "slate-gray": [
                    "#09090b",
                    "#1d1d22",
                    "#313138",
                    "#45444f",
                    "#595866",
                    "#6d6c7d",
                    "#838292",
                    "#9a9aa7",
                    "#b2b1bb",
                    "#c9c9d0",
                    "#e1e0e4",
                    "#f8f8f9",
                ],
                blue: [
                    "#030b18",
                    "#071e3f",
                    "#0c3166",
                    "#10448d",
                    "#1556b4",
                    "#1969db",
                    "#317fed",
                    "#5797f0",
                    "#7daef4",
                    "#a3c6f7",
                    "#c9ddfa",
                    "#eff5fe",
                ],
                indigo: [
                    "#080614",
                    "#19143f",
                    "#2a216a",
                    "#3a2e95",
                    "#4b3bc0",
                    "#5c49eb",
                    "#725fff",
                    "#8c7cff",
                    "#a69aff",
                    "#c0b7ff",
                    "#dad5ff",
                    "#f4f3ff",
                ],
                violet: [
                    "#110517",
                    "#2e0d3e",
                    "#4b1465",
                    "#681c8c",
                    "#8424b3",
                    "#a12cda",
                    "#b543ec",
                    "#c366f0",
                    "#d089f3",
                    "#deabf7",
                    "#eccefa",
                    "#f9f0fe",
                ],
                magenta: [
                    "#13040f",
                    "#350a2c",
                    "#581148",
                    "#7b1765",
                    "#9e1e82",
                    "#c1249e",
                    "#d43cb2",
                    "#dc61c1",
                    "#e485cf",
                    "#eca9dd",
                    "#f4ceec",
                    "#fcf2fa",
                ],
                red: [
                    "#120205",
                    "#39050f",
                    "#5f0819",
                    "#860b24",
                    "#ac0e2e",
                    "#d31138",
                    "#e7284e",
                    "#ec506f",
                    "#f07790",
                    "#f49fb0",
                    "#f9c7d1",
                    "#fdeef1",
                ],
                "red-orange": [
                    "#190b05",
                    "#3d1307",
                    "#601b0a",
                    "#84240c",
                    "#a72c0e",
                    "#cb3411",
                    "#ee3c13",
                    "#fe562f",
                    "#fe7d5e",
                    "#ffa48e",
                    "#ffccbe",
                    "#fff3ee",
                ],
                orange: [
                    "#150d04",
                    "#2e1c08",
                    "#472a0c",
                    "#603910",
                    "#794714",
                    "#a65d13",
                    "#d37413",
                    "#ff8a14",
                    "#ffa54a",
                    "#ffc081",
                    "#ffdab7",
                    "#fff5ed",
                ],
                gold: [
                    "#140e05",
                    "#2c1f0a",
                    "#432f0e",
                    "#5b4013",
                    "#725118",
                    "#946818",
                    "#d4950d",
                    "#eeb028",
                    "#f2c259",
                    "#f7d38a",
                    "#fbe5bc",
                    "#fff5e9",
                ],
                yellow: [
                    "#111006",
                    "#252405",
                    "#3a3804",
                    "#4e4d03",
                    "#636101",
                    "#777500",
                    "#ccc500",
                    "#fcf433",
                    "#fdf67a",
                    "#fdf89b",
                    "#fef9bb",
                    "#fefadb",
                ],
                green: [
                    "#091108",
                    "#0f2611",
                    "#153c1a",
                    "#1b5122",
                    "#21662b",
                    "#25833a",
                    "#26b056",
                    "#35d272",
                    "#63dd90",
                    "#90e8ae",
                    "#bdf3cc",
                    "#eafeea",
                ],
                teal: [
                    "#07100c",
                    "#0c231a",
                    "#113628",
                    "#164936",
                    "#1b5b45",
                    "#177f63",
                    "#12a282",
                    "#2abb9b",
                    "#5acab1",
                    "#8bdac7",
                    "#bbe9dc",
                    "#ecf8f2",
                ],
                cyan: [
                    "#0a1211",
                    "#102425",
                    "#153639",
                    "#1b484c",
                    "#215a60",
                    "#247981",
                    "#24a9b6",
                    "#28d6e6",
                    "#57e0ec",
                    "#85eaf2",
                    "#b4f5f9",
                    "#e2ffff",
                ],
                modes: {},
            },
            borderStyles: [],
            borderWidths: [],
            fontSizes: [],
            space: [],
            text: {},
        },
        natural: {
            name: "Color System - RGB | Natural",
            space: [],
            borderStyles: [],
            fonts: {},
            description: "",
            borderWidths: [],
            fontSizes: [],
            borderRadius: [],
            lineHeights: {},
            colors: {
                "overlay-tint": [
                    "hsla(0, 0%, 100%, .035)",
                    "hsla(0, 0%, 100%, 0.1)",
                    "hsla(0, 0%, 100%, 0.19)",
                    "hsla(0, 0%, 100%, .28)",
                    "hsla(0, 0%, 100%, 0.36)",
                    "hsla(0, 0%, 100%, 0.45)",
                    "hsla(0, 0%, 100%, .55)",
                    "hsla(0, 0%, 100%, 0.64)",
                    "hsla(0, 0%, 100%, .73)",
                    "hsla(0, 0%, 100%, .815)",
                    "hsla(0, 0%, 100%, .895)",
                    "hsla(0, 0%, 100%, .94)",
                ],
                "overlay-shadow": [
                    "hsla(0, 0%, 0%, 0.94)",
                    "hsla(0, 0%, 0%, 0.899)",
                    "hsla(0, 0%, 0%, 0.8)",
                    "hsla(0, 0%, 0%, 0.69)",
                    "hsla(0, 0%, 0%, 0.6)",
                    "hsla(0, 0%, 0%, 0.5)",
                    "hsla(0, 0%, 0%, 0.41)",
                    "hsla(0, 0%, 0%, 0.32)",
                    "hsla(0, 0%, 0%, 0.24)",
                    "hsla(0, 0%, 0%, 0.16)",
                    "hsla(0, 0%, 0%, 0.07)",
                    "hsla(0, 0%, 0%, 0.035)",
                ],
                gray: [
                    "#000000",
                    "#1a1a1a",
                    "#353535",
                    "#4e4e4e",
                    "#686868",
                    "#808080",
                    "#979797",
                    "#adadad",
                    "#c2c2c2",
                    "#d7d7d7",
                    "#ebebeb",
                    "#ffffff",
                ],
                "slate-gray": [
                    "#0c0c0e",
                    "#26262c",
                    "#403f49",
                    "#595865",
                    "#71707f",
                    "#878697",
                    "#9d9cad",
                    "#b1b0c0",
                    "#c4c4d0",
                    "#d7d6e0",
                    "#e8e8ee",
                    "#fafafb",
                ],
                blue: [
                    "#020d23",
                    "#05235b",
                    "#0b3991",
                    "#134fc1",
                    "#1e64e9",
                    "#2e7aff",
                    "#448fff",
                    "#5fa4ff",
                    "#7fb9ff",
                    "#a2cdff",
                    "#c7e2ff",
                    "#eef6ff",
                ],
                indigo: [
                    "#09091c",
                    "#1d1b55",
                    "#312e8a",
                    "#4541bb",
                    "#5a55e5",
                    "#6e6aff",
                    "#847fff",
                    "#9a95ff",
                    "#b0adff",
                    "#c7c4ff",
                    "#dedcff",
                    "#f5f5ff",
                ],
                violet: [
                    "#180222",
                    "#3f075b",
                    "#640d8f",
                    "#8715bf",
                    "#a621e8",
                    "#c031ff",
                    "#d547ff",
                    "#e462ff",
                    "#ef81ff",
                    "#f6a4ff",
                    "#fbc9ff",
                    "#feefff",
                ],
                magenta: [
                    "#150311",
                    "#3c0a31",
                    "#631051",
                    "#8b1771",
                    "#b21d91",
                    "#d923b1",
                    "#eb3cc4",
                    "#ef60cf",
                    "#f384da",
                    "#f6a9e5",
                    "#facdf0",
                    "#fef2fb",
                ],
                red: [
                    "#140407",
                    "#3f0c17",
                    "#691526",
                    "#941d35",
                    "#be2644",
                    "#e92e54",
                    "#fd446a",
                    "#fe6785",
                    "#fe89a1",
                    "#feacbc",
                    "#ffced8",
                    "#fff1f4",
                ],
                "red-orange": [
                    "#140602",
                    "#3d1407",
                    "#66210c",
                    "#8f2f10",
                    "#b83c15",
                    "#e24a1a",
                    "#f66030",
                    "#f87d56",
                    "#f99a7d",
                    "#fbb8a3",
                    "#fdd5c9",
                    "#fef3ef",
                ],
                orange: [
                    "#170a00",
                    "#411f05",
                    "#693309",
                    "#8e440a",
                    "#af5108",
                    "#ec5f00",
                    "#ff780d",
                    "#ff8b2c",
                    "#ffa355",
                    "#ffbe85",
                    "#ffdbb9",
                    "#fffaf0",
                ],
                gold: [
                    "#0f0b00",
                    "#2d2204",
                    "#4c3806",
                    "#6d5005",
                    "#936900",
                    "#c38800",
                    "#eda500",
                    "#ffbd0b",
                    "#ffce34",
                    "#ffde6b",
                    "#ffecab",
                    "#fffbf0",
                ],
                yellow: [
                    "#0d0e01",
                    "#2a2905",
                    "#474309",
                    "#625c0b",
                    "#7c730c",
                    "#93880a",
                    "#d7c500",
                    "#eada21",
                    "#f0e345",
                    "#f4ec72",
                    "#f8f5a6",
                    "#fbfedc",
                ],
                green: [
                    "#011409",
                    "#01311b",
                    "#024d2d",
                    "#02683c",
                    "#018149",
                    "#009953",
                    "#00be5c",
                    "#03d662",
                    "#50eb94",
                    "#89f2b8",
                    "#b9f8d7",
                    "#ebfff7",
                ],
                teal: [
                    "#07100c",
                    "#13261c",
                    "#1c3c2c",
                    "#1d533e",
                    "#117156",
                    "#039474",
                    "#11b495",
                    "#2bc3a7",
                    "#51d1b9",
                    "#7fdecc",
                    "#b4ebdf",
                    "#ecf8f2",
                ],
                cyan: [
                    "#031111",
                    "#092e2f",
                    "#0e4a4c",
                    "#126568",
                    "#157e81",
                    "#169498",
                    "#12b8be",
                    "#1cdae2",
                    "#40e6ed",
                    "#6feff4",
                    "#a7f7fa",
                    "#e5ffff",
                ],
                modes: {
                    0: {
                        background: "#ebebeb",
                        text: "#353535",
                        border: "hsla(0, 0%, 0%, 0.16)",
                        primary: "#134fc1",
                        accent: "#c2c2c2",
                        muted: "#4e4e4e",
                    },
                    1: {
                        background: "#353535",
                        text: "#c2c2c2",
                        border: "#4e4e4e",
                        primary: "#5fa4ff",
                        accent: "#1a1a1a",
                        muted: "#adadad",
                    },
                    default: {
                        background: "#ffffff",
                        text: "#000000",
                        border: "#d7d7d7",
                        primary: "#1e64e9",
                        accent: "#d7d7d7",
                        muted: "#686868",
                    },
                    dark: {
                        background: "#000000",
                        text: "#ffffff",
                        border: "#07100c",
                        primary: "#2e7aff",
                        accent: "#1a1a1a",
                        muted: "#808080",
                    },
                },
            },
            breakpoints: [],
            text: {},
        }
    },
    lab: {
        bspline: {
            lineHeights: {},
            description: "Open source color system\n\n156 colors\n8,212 Accessible color combos\n\n12 steps in each scale. Every color has at least one accessible match within the same hue group.\n\nFirst 6 steps are accessible with white, last 6 steps are accessible with black.",
            colors: {
                gray: [
                    "#000000",
                    "#171717",
                    "#272727",
                    "#393939",
                    "#4c4c4c",
                    "#616161",
                    "#777777",
                    "#8f8f8f",
                    "#a9a9a9",
                    "#c5c5c5",
                    "#e1e1e1",
                    "#ffffff",
                ],
                "gray-blue": [
                    "#0c0d0e",
                    "#1c1e21",
                    "#2b2e33",
                    "#3b3f46",
                    "#4c525a",
                    "#5f656e",
                    "#747a84",
                    "#8a9099",
                    "#a3a8b0",
                    "#bcc0c6",
                    "#d7dade",
                    "#f3f4f5",
                ],
                blue: [
                    "#0c0f18",
                    "#161f34",
                    "#1e2f53",
                    "#274071",
                    "#34538e",
                    "#4666a8",
                    "#5d7bbf",
                    "#7891d1",
                    "#95a8df",
                    "#b3c0eb",
                    "#d2daf4",
                    "#f2f4fc",
                ],
                indigo: [
                    "#120e1a",
                    "#211d3a",
                    "#312b5c",
                    "#413a7e",
                    "#544b9d",
                    "#695eb9",
                    "#7f72d0",
                    "#9789e1",
                    "#afa2ed",
                    "#c7bcf6",
                    "#dfd7fb",
                    "#f5f3fe",
                ],
                violet: [
                    "#170b19",
                    "#2e1637",
                    "#471e57",
                    "#602877",
                    "#7a3595",
                    "#9247b0",
                    "#a95cc6",
                    "#be76d8",
                    "#d092e6",
                    "#e0b1f0",
                    "#eed1f7",
                    "#faf1fd",
                ],
                magenta: [
                    "#190b14",
                    "#351529",
                    "#521c3f",
                    "#6f2456",
                    "#8c306c",
                    "#a64283",
                    "#bd5898",
                    "#d173ad",
                    "#e190c0",
                    "#edafd3",
                    "#f6d0e5",
                    "#fdf1f7",
                ],
                red: [
                    "#1c0b07",
                    "#391412",
                    "#591b1a",
                    "#782323",
                    "#972f2f",
                    "#b3403e",
                    "#cb5752",
                    "#df726a",
                    "#ee8f86",
                    "#f9afa6",
                    "#ffcfca",
                    "#fff1ef",
                ],
                orange: [
                    "#1e0c03",
                    "#3a1509",
                    "#591d0e",
                    "#782614",
                    "#96331c",
                    "#b2452a",
                    "#ca5b3e",
                    "#de7558",
                    "#ee9378",
                    "#f9b29c",
                    "#ffd2c4",
                    "#fff3ef",
                ],
                gold: [
                    "#161407",
                    "#2d260f",
                    "#453813",
                    "#5d4b15",
                    "#755d16",
                    "#8d6f16",
                    "#d8ad20",
                    "#f1c64d",
                    "#f8d47a",
                    "#fbe0a4",
                    "#feedca",
                    "#fff8ec",
                ],
                lime: [
                    "#151809",
                    "#242a11",
                    "#333e15",
                    "#435219",
                    "#53661c",
                    "#637a1e",
                    "#8baa26",
                    "#b7d843",
                    "#d8f37c",
                    "#e6fa9f",
                    "#effdba",
                    "#f6fed5",
                ],
                green: [
                    "#0a1209",
                    "#142315",
                    "#1a351d",
                    "#204825",
                    "#245c2d",
                    "#29813b",
                    "#34b753",
                    "#5cda71",
                    "#8cea94",
                    "#b0f2b1",
                    "#cdf7cc",
                    "#e8fce7",
                ],
                teal: [
                    "#09120e",
                    "#12221b",
                    "#173327",
                    "#1b4434",
                    "#1f5842",
                    "#23785a",
                    "#32ba8b",
                    "#59dcaa",
                    "#81e8bd",
                    "#a4efce",
                    "#c4f4de",
                    "#e1faee",
                ],
                cyan: [
                    "#091010",
                    "#172424",
                    "#203839",
                    "#294d4e",
                    "#326264",
                    "#39787a",
                    "#4cb0b4",
                    "#67d9dd",
                    "#95eef1",
                    "#b3f4f6",
                    "#caf8f9",
                    "#e1fcfc",
                ],
                modes: {},
            },
            space: [],
            name: "Color System - LAB (B-spline)",
            borderStyles: [],
            borderWidths: [],
            gradients: {},
            fonts: {},
            breakpoints: [],
            borderRadius: [],
            fontSizes: [],
            text: {},
        },
        linear: {
            borderWidths: [],
            borderRadius: [],
            borderStyles: [],
            fontSizes: [],
            description: "180 colors\n10,918 accessible combinations\n\n1st 6 steps are accessible withe white\nLast 6 steps are accessible with black",
            lineHeights: {},
            breakpoints: [],
            name: "Color System - LAB (Linear)",
            space: [],
            colors: {
                gray: [
                    "#000000",
                    "#1a1a1a",
                    "#2d2d2d",
                    "#414141",
                    "#565656",
                    "#6d6d6d",
                    "#838383",
                    "#9b9b9b",
                    "#b3b3b3",
                    "#cccccc",
                    "#e5e5e5",
                    "#ffffff",
                ],
                "gray-blue": [
                    "#101112",
                    "#212225",
                    "#313339",
                    "#42454e",
                    "#545864",
                    "#676c7b",
                    "#7c8190",
                    "#9397a4",
                    "#abadb8",
                    "#c3c5cc",
                    "#dbdce1",
                    "#f4f5f6",
                ],
                blue: [
                    "#0b0e15",
                    "#162032",
                    "#1d3251",
                    "#224573",
                    "#255997",
                    "#266ebc",
                    "#4683d3",
                    "#7099db",
                    "#93afe4",
                    "#b3c6ec",
                    "#d3ddf4",
                    "#f2f5fc",
                ],
                indigo: [
                    "#110b16",
                    "#241935",
                    "#382457",
                    "#4d307c",
                    "#623ca3",
                    "#7848cb",
                    "#905ee2",
                    "#a77be9",
                    "#bc98ee",
                    "#d1b6f4",
                    "#e4d4f9",
                    "#f7f2fd",
                ],
                violet: [
                    "#180c1a",
                    "#301638",
                    "#4b1d5a",
                    "#67237e",
                    "#8527a4",
                    "#a42bcc",
                    "#bb48e1",
                    "#ca6ee7",
                    "#d890ed",
                    "#e5b1f3",
                    "#f1d1f8",
                    "#fbf1fd",
                ],
                magenta: [
                    "#180b11",
                    "#351624",
                    "#551c38",
                    "#76214d",
                    "#9a2563",
                    "#be2779",
                    "#d5468f",
                    "#e06ea3",
                    "#ea91b7",
                    "#f2b2cc",
                    "#f9d3e1",
                    "#fef3f7",
                ],
                red: [
                    "#180a0a",
                    "#351518",
                    "#561b23",
                    "#79202f",
                    "#9d233b",
                    "#c42448",
                    "#dd425c",
                    "#e86b77",
                    "#f18e94",
                    "#f8b0b2",
                    "#fdd1d1",
                    "#fff1f1",
                ],
                "red-orange": [
                    "#180d06",
                    "#371a0f",
                    "#592414",
                    "#7d2d18",
                    "#a2361c",
                    "#ca3f1f",
                    "#e55631",
                    "#ef7855",
                    "#f79779",
                    "#fdb69e",
                    "#ffd4c4",
                    "#fff2ec",
                ],
                orange: [
                    "#150d04",
                    "#2a1b0c",
                    "#412810",
                    "#5a3612",
                    "#734414",
                    "#9d5b15",
                    "#ce7513",
                    "#f3902a",
                    "#fba95e",
                    "#ffc28d",
                    "#ffdbbd",
                    "#fff5ed",
                ],
                gold: [
                    "#140e05",
                    "#271e0d",
                    "#3b2d12",
                    "#513d14",
                    "#674e15",
                    "#8c6916",
                    "#c99612",
                    "#efb634",
                    "#f6c666",
                    "#fbd593",
                    "#fee5be",
                    "#fff5e9",
                ],
                yellow: [
                    "#111000",
                    "#23220c",
                    "#363412",
                    "#4a4716",
                    "#5f5b1a",
                    "#7a7420",
                    "#ada42d",
                    "#e3d73c",
                    "#f1e56a",
                    "#f7eb95",
                    "#fcf2be",
                    "#fef9e7",
                ],
                "yellow-green": [
                    "#171609",
                    "#262612",
                    "#373817",
                    "#484a1b",
                    "#5a5d1f",
                    "#6d7223",
                    "#a1ab2d",
                    "#d1de3c",
                    "#dbe469",
                    "#e4eb90",
                    "#ecf2b4",
                    "#f3f8d7",
                ],
                green: [
                    "#091108",
                    "#132213",
                    "#18341a",
                    "#1d4721",
                    "#215b28",
                    "#257431",
                    "#28993d",
                    "#28c049",
                    "#5bd669",
                    "#8ee392",
                    "#baeeba",
                    "#e2f9e2",
                ],
                teal: [
                    "#08110b",
                    "#122318",
                    "#163522",
                    "#1a492d",
                    "#1c5d38",
                    "#1d7a4f",
                    "#1a9867",
                    "#1eb680",
                    "#66c79b",
                    "#96d8b6",
                    "#c2e8d2",
                    "#ecf8ef",
                ],
                cyan: [
                    "hsl(186.67,27.27%,6.47%)",
                    "hsl(186.67,31.03%,11.37%)",
                    "hsl(186,36.59%,16.08%)",
                    "hsl(186.67,42.86%,20.59%)",
                    "hsl(186,46.88%,25.1%)",
                    "hsl(186.14,53.66%,32.16%)",
                    "hsl(185.14,63.06%,43.53%)",
                    "hsl(185.26,63.13%,57.45%)",
                    "hsl(185.68,60.51%,69.22%)",
                    "hsl(185.71,58.88%,79.02%)",
                    "hsl(185.14,57.38%,88.04%)",
                    "hsl(180,52.94%,96.67%)",
                ],
                modes: {
                    0: {
                        background: "#fff5ed",
                        text: "#150d04",
                        border: "#fff5ed",
                        primary: "#ca3f1f",
                        accent: "#122318",
                        muted: "#5a3612",
                    },
                    1: {
                        background: "#110b16",
                        text: "#f7f2fd",
                        border: "#f7f2fd",
                        primary: "hsl(185.68,60.51%,69.22%)",
                        accent: "#fbd593",
                        muted: "#d1b6f4",
                    },
                    2: {
                        background: "#241935",
                        text: "#e4d4f9",
                        border: "#180c1a",
                        primary: "#e4d4f9",
                        accent: "#e86b77",
                        muted: "#d890ed",
                    },
                    default: {
                        background: "#ffffff",
                        text: "#000000",
                        border: "#cccccc",
                        primary: "#266ebc",
                        accent: "#e5e5e5",
                        muted: "#6d6d6d",
                    },
                    dark: {
                        background: "#000000",
                        text: "#ffffff",
                        border: "#101112",
                        primary: "#4683d3",
                        accent: "#2d2d2d",
                        muted: "#838383",
                    },
                    "dim-dark": {
                        background: "#2d2d2d",
                        text: "#b3b3b3",
                        border: "#1a1a1a",
                        primary: "#9b9b9b",
                        accent: "#414141",
                        muted: "#9b9b9b",
                    },
                    "dim-light": {
                        background: "#cccccc",
                        text: "#414141",
                        border: "#9b9b9b",
                        primary: "#565656",
                        accent: "#b3b3b3",
                        muted: "#565656",
                    },
                },
            },
            fonts: {},
            text: {},
        },
        monotone: {
            lineHeights: {},
            space: [],
            fontSizes: [],
            fonts: {},
            borderStyles: [],
            colors: {
                gray: [
                    "#000000",
                    "#1a1a1a",
                    "#2c2c2c",
                    "#404040",
                    "#555555",
                    "#6b6b6b",
                    "#828282",
                    "#999999",
                    "#b2b2b2",
                    "#cbcbcb",
                    "#e5e5e5",
                    "#ffffff",
                ],
                "gray-blue": [
                    "#0d0e11",
                    "#1f2027",
                    "#2f313e",
                    "#404456",
                    "#52576f",
                    "#656b86",
                    "#7a809c",
                    "#9196b0",
                    "#a9adc2",
                    "#c2c4d4",
                    "#dbdce5",
                    "#f4f5f7",
                ],
                blue: [
                    "#0e101b",
                    "#142040",
                    "#0f306b",
                    "#004196",
                    "#0053bf",
                    "#0066e1",
                    "#387bf9",
                    "#6590ff",
                    "#8da7ff",
                    "#b1c0ff",
                    "#d3d9ff",
                    "#f1f2ff",
                ],
                indigo: [
                    "#140d1a",
                    "#271a3d",
                    "#3b2465",
                    "#502f8d",
                    "#653cb4",
                    "#7c4cd4",
                    "#9462eb",
                    "#ab7cf8",
                    "#c198fd",
                    "#d5b7fe",
                    "#e7d6fd",
                    "#f9f4fe",
                ],
                violet: [
                    "#160a15",
                    "#331434",
                    "#531557",
                    "#75147c",
                    "#96159f",
                    "#b425be",
                    "#cc43d5",
                    "#de65e5",
                    "#eb89ee",
                    "#f3adf3",
                    "#f8d0f7",
                    "#fcf2fc",
                ],
                magenta: [
                    "hsl(336.92,39.39%,6.47%)",
                    "hsl(333.53,45.95%,14.51%)",
                    "hsl(331.94,55.36%,21.96%)",
                    "hsl(330.32,62.91%,29.61%)",
                    "hsl(328.42,71.12%,36.67%)",
                    "hsl(327.12,80.09%,43.33%)",
                    "hsl(330,73.68%,55.29%)",
                    "hsl(333.44,75.72%,66.08%)",
                    "hsl(335.53,79.84%,74.71%)",
                    "hsl(337.3,84.09%,82.75%)",
                    "hsl(338.67,88.24%,90%)",
                    "hsl(337.5,100%,96.86%)",
                ],
                red: [
                    "#160807",
                    "#371214",
                    "#5d131c",
                    "#830d25",
                    "#a90830",
                    "#cb1b3f",
                    "#e53c52",
                    "#f7616b",
                    "#ff8789",
                    "#ffacab",
                    "#ffd1cf",
                    "#fff3f3",
                ],
                orange: [
                    "#140a02",
                    "#301a04",
                    "#4f2500",
                    "#6e3200",
                    "#8e4000",
                    "#ab5100",
                    "#c56612",
                    "#d97e37",
                    "#e8995e",
                    "#f2b68a",
                    "#f9d3b9",
                    "#fdf0e7",
                ],
                gold: [
                    "#130f05",
                    "#352b0d",
                    "#5a4908",
                    "#826900",
                    "#a98800",
                    "#cba500",
                    "#e5bc1a",
                    "#f5cd46",
                    "#feda6e",
                    "#ffe497",
                    "#ffeec0",
                    "#fff8e8",
                ],
                green: [
                    "#07100b",
                    "#0d2519",
                    "#073a25",
                    "#005031",
                    "#00673f",
                    "#007e4f",
                    "#1f9464",
                    "#4aa97c",
                    "#74bd97",
                    "#9dd0b4",
                    "#c6e3d2",
                    "#edf6f1",
                ],
                teal: [
                    "#060e0f",
                    "#0e2325",
                    "#08383b",
                    "#004d53",
                    "#00646b",
                    "#007b82",
                    "#249198",
                    "#50a6ad",
                    "#7abbc0",
                    "#a3cfd2",
                    "#cbe3e5",
                    "#f2f8f8",
                ],
                modes: {},
            },
            description: "Color system \n\n132 colors\n5,390 accessible color combos\n\nThe first 6 steps in each scale are accessible with white, \nthe last 6 steps are accessible with black. Except for gold of course.",
            name: "Color system - LAB (Monotone)",
            borderRadius: [],
            breakpoints: [],
            borderWidths: [],
            text: {},
        }
    },
    lch: {
        linear: {
            fontSizes: [],
            name: "Color System - LCH (Linear)",
            description: "Scales generated with LCH - Linear\n\n\n156 colors\n7,256 accessible combos",
            borderStyles: [],
            breakpoints: [],
            borderWidths: [],
            colors: {
                gray: [
                    "#000000",
                    "#1a1a1a",
                    "#2c2c2c",
                    "#404040",
                    "#565656",
                    "#6c6c6c",
                    "#838383",
                    "#9a9a9a",
                    "#b2b2b2",
                    "#cbcbcb",
                    "#e5e5e5",
                    "#ffffff",
                ],
                "slate-gray": [
                    "#101012",
                    "#202024",
                    "#302f37",
                    "#41404a",
                    "#53515f",
                    "#666375",
                    "#7a778a",
                    "#908e9e",
                    "#a7a5b2",
                    "#bfbdc7",
                    "#d7d6dc",
                    "#f0eff2",
                ],
                blue: [
                    "#141721",
                    "#1f273c",
                    "#293759",
                    "#344978",
                    "#3e5b98",
                    "#486eb9",
                    "#6483ca",
                    "#8298d4",
                    "#9faedd",
                    "#bbc4e7",
                    "#d6dbf1",
                    "#f1f3fa",
                ],
                indigo: [
                    "#191521",
                    "#2b223c",
                    "#3e2f5a",
                    "#523d79",
                    "#664c99",
                    "#7c5bbb",
                    "#9171cb",
                    "#a68ad5",
                    "#baa3df",
                    "#cebde8",
                    "#e2d7f1",
                    "#f5f1fb",
                ],
                violet: [
                    "#1c121b",
                    "#341d33",
                    "#4d284d",
                    "#683368",
                    "#843e84",
                    "#a24aa2",
                    "#b661b5",
                    "#c47dc2",
                    "#d299cf",
                    "#dfb5dd",
                    "#ecd1ea",
                    "#f8edf7",
                ],
                magenta: [
                    "#221319",
                    "#3d1c2b",
                    "#59253d",
                    "#782f51",
                    "#983766",
                    "#b9407b",
                    "#cb5a8f",
                    "#d779a2",
                    "#e197b5",
                    "#ebb3c9",
                    "#f3d0dd",
                    "#fbedf2",
                ],
                red: [
                    "#24120e",
                    "#411b17",
                    "#5f241e",
                    "#7f2c26",
                    "#a1332d",
                    "#c43b35",
                    "#d8564b",
                    "#e37669",
                    "#ed9487",
                    "#f5b2a7",
                    "#facfc7",
                    "#feece9",
                ],
                "red-orange": [
                    "#20110a",
                    "#3a1c13",
                    "#572619",
                    "#75311e",
                    "#953b24",
                    "#b5462a",
                    "#cb5d3f",
                    "#d87b5f",
                    "#e4977f",
                    "#eeb4a1",
                    "#f6d0c4",
                    "#fcede8",
                ],
                orange: [
                    "#271807",
                    "#3d240c",
                    "#55300f",
                    "#6e3c10",
                    "#8a4a10",
                    "#aa580e",
                    "#cc711f",
                    "#ef933c",
                    "#f7a760",
                    "#f3b685",
                    "#fad2b3",
                    "#ffefe3",
                ],
                yellow: [
                    "#201a0c",
                    "#322811",
                    "#453714",
                    "#594717",
                    "#6d5719",
                    "#83691a",
                    "#b3901a",
                    "#e4b814",
                    "#f4cc4c",
                    "#fad97d",
                    "#fee8b3",
                    "#fff6e2",
                ],
                green: [
                    "#101b0f",
                    "#152d17",
                    "#1a401e",
                    "#1d5325",
                    "#1f682d",
                    "#207d34",
                    "#45914e",
                    "#68a56c",
                    "#8ab98b",
                    "#abcdab",
                    "#cce1cc",
                    "#eef5ee",
                ],
                teal: [
                    "#0f1914",
                    "#152b21",
                    "#1a3e2e",
                    "#1e523b",
                    "#20674a",
                    "#227c58",
                    "#43916e",
                    "#67a487",
                    "#89b8a0",
                    "#abccbb",
                    "#cce0d5",
                    "#eef5f1",
                ],
                cyan: [
                    "#111b1b",
                    "#172c2c",
                    "#1c3e3e",
                    "#205151",
                    "#236465",
                    "#26797a",
                    "#468d8d",
                    "#69a0a0",
                    "#89b4b4",
                    "#a9c8c8",
                    "#cadddd",
                    "#eaf2f1",
                ],
                modes: {
                    default: {
                        background: "#f5f1fb",
                        text: "#191521",
                        border: "#f5f1fb",
                        primary: "#ffefe3",
                        accent: "#664c99",
                        muted: "#3e2f5a",
                    },
                    dark: {
                        background: "#221319",
                        text: "#fbedf2",
                        border: "#fbedf2",
                        primary: "#24120e",
                        accent: "#ebb3c9",
                        muted: "#cb5a8f",
                    },
                    "dim-dark": {
                        background: "#0f1914",
                        text: "#eef5f1",
                        border: "#eef5f1",
                        primary: "#152b21",
                        accent: "#bfbdc7",
                        muted: "#43916e",
                    },
                    "dim-light": {
                        background: "#ffffff",
                        text: "#000000",
                        border: "#ffffff",
                        primary: "#ef933c",
                        accent: "#565656",
                        muted: "#1a1a1a",
                    },
                },
            },
            borderRadius: [],
            space: [],
            fonts: {},
            lineHeights: {},
            text: {},
        },
        natural: {

            borderRadius: [],
            breakpoints: [],
            borderWidths: [],
            fonts: {},
            fontSizes: [],
            colors: {
                gray: [
                    "#000000",
                    "#1b1b1b",
                    "#2f2f2f",
                    "#444444",
                    "#5b5b5b",
                    "#717171",
                    "#898989",
                    "#a0a0a0",
                    "#b7b7b7",
                    "#cfcfcf",
                    "#e7e7e7",
                    "#ffffff",
                ],
                "gray-blue": [
                    "#0e0e10",
                    "#1f2025",
                    "#303139",
                    "#42444f",
                    "#555765",
                    "#696b7b",
                    "#7e8090",
                    "#9496a5",
                    "#abacba",
                    "#c2c3ce",
                    "#dadbe2",
                    "#f3f3f5",
                ],
                blue: [
                    "#0b0d18",
                    "#161e3a",
                    "#1b2e5e",
                    "#224081",
                    "#2e52a3",
                    "#4165c0",
                    "#5a7ad8",
                    "#7790e9",
                    "#95a7f5",
                    "#b4bffb",
                    "#d3d8fe",
                    "#f1f2ff",
                ],
                indigo: [
                    "#120a1f",
                    "#1f174d",
                    "#2a207d",
                    "#362cac",
                    "#473ad6",
                    "#5e4bf9",
                    "#7a60ff",
                    "#9779ff",
                    "#b395ff",
                    "#cdb3ff",
                    "#e4d2ff",
                    "#f9f3ff",
                ],
                violet: [
                    "#15091c",
                    "#2d1447",
                    "#471976",
                    "#6121a3",
                    "#7b2ccc",
                    "#953def",
                    "#ad55ff",
                    "#c470ff",
                    "#d78eff",
                    "#e7aeff",
                    "#f3ceff",
                    "#fcefff",
                ],
                magenta: [
                    "#170917",
                    "#351338",
                    "#54185b",
                    "#741e7e",
                    "#93289e",
                    "#af3abb",
                    "#c752d3",
                    "#db6fe4",
                    "#ea8df0",
                    "#f4aef8",
                    "#fbcefc",
                    "#feeffe",
                ],
                red: [
                    "#190806",
                    "#3b1312",
                    "#60171b",
                    "#851d25",
                    "#a82831",
                    "#c83a41",
                    "#e25355",
                    "#f5706d",
                    "#ff9089",
                    "#ffb0a9",
                    "#ffd2cc",
                    "#fff3f2",
                ],
                "red-orange": [
                    "#1d0b03",
                    "#3d170c",
                    "#5f210f",
                    "#812c10",
                    "#a23810",
                    "#c04711",
                    "#dc5716",
                    "#f2691f",
                    "#ff8a3e",
                    "#ffb274",
                    "#ffd8b5",
                    "#fff3ec",
                ],
                orange: [
                    "#1a1006",
                    "#301e0d",
                    "#472c0f",
                    "#5e3a0d",
                    "#754805",
                    "#a75c00",
                    "#df7c03",
                    "#e9912a",
                    "#f0a94f",
                    "#f3c379",
                    "#f7dcaa",
                    "#fcf4e0",
                ],
                yellow: [
                    "#1b1a09",
                    "#2b2a0f",
                    "#3e3a11",
                    "#534c12",
                    "#6a5f12",
                    "#83740f",
                    "#ab9903",
                    "#d0bf05",
                    "#ece02e",
                    "#fcf766",
                    "#ffffa5",
                    "#ffffe4",
                ],
                green: [
                    "#0a1207",
                    "#132311",
                    "#163618",
                    "#16491f",
                    "#0f5e28",
                    "#007d34",
                    "#00b54f",
                    "#36d971",
                    "#6ae78a",
                    "#97f1a7",
                    "#c2f9c8",
                    "#e9feea",
                ],
                teal: [
                    "#08120e",
                    "#132520",
                    "#173a33",
                    "#145048",
                    "#00675e",
                    "#008170",
                    "#009a7d",
                    "#00b289",
                    "#3fc99a",
                    "#7cdcb4",
                    "#b6edd4",
                    "#f0fbf6",
                ],
                cyan: [
                    "#091112",
                    "#152629",
                    "#1d3c40",
                    "#225257",
                    "#24676d",
                    "#237a82",
                    "#0298a3",
                    "#00bccc",
                    "#53cedc",
                    "#8ddee8",
                    "#c5eef4",
                    "#e1f7fa",
                ],
                modes: {},
            },
            borderStyles: [],
            lineHeights: {},
            description: "Open source color system for use with generative art, app design, and prototyping\n\nUses LCH - Natural to derive scales\n\n156 colors\n7,768 accessible color combos\n\nEach color has at least one accessible match within the scale. First 6 steps are accessible with white, last six steps are accessible with black.\n",
            name: "Color System - LCH (Natural)",
            space: [],
            text: {},

        },
        bspline: {

            borderWidths: [],
            breakpoints: [],
            colors: {
                gray: [
                    "#000000",
                    "#181818",
                    "#292929",
                    "#3b3b3b",
                    "#4f4f4f",
                    "#646464",
                    "#7a7a7a",
                    "#939393",
                    "#acacac",
                    "#c7c7c7",
                    "#e2e2e2",
                    "#ffffff",
                ],
                "slate-gray": [
                    "#0d0d0e",
                    "#1e1f20",
                    "#2d3032",
                    "#3e4145",
                    "#505458",
                    "#63686d",
                    "#787d82",
                    "#8e9397",
                    "#a6aaae",
                    "#bec1c4",
                    "#d8dadc",
                    "#f2f3f3",
                ],
                blue: [
                    "#0b0c15",
                    "#181d31",
                    "#222c4f",
                    "#2e3d6d",
                    "#3c4f8a",
                    "#4e62a5",
                    "#6476bc",
                    "#7e8dce",
                    "#99a4de",
                    "#b6bdea",
                    "#d3d7f3",
                    "#f1f2fb",
                ],
                indigo: [
                    "#14101d",
                    "#221e3a",
                    "#322b59",
                    "#433a78",
                    "#554b95",
                    "#695daf",
                    "#7f72c5",
                    "#9688d7",
                    "#aea0e4",
                    "#c5baef",
                    "#ddd5f6",
                    "#f4f1fc",
                ],
                violet: [
                    "#170f19",
                    "#2c1c32",
                    "#41284c",
                    "#583666",
                    "#6e4580",
                    "#845798",
                    "#9a6cae",
                    "#af83c0",
                    "#c29cd1",
                    "#d5b7e0",
                    "#e6d3ed",
                    "#f7f0f9",
                ],
                magenta: [
                    "#1c0f14",
                    "#361925",
                    "#522337",
                    "#6e2f4a",
                    "#893d5e",
                    "#a24f72",
                    "#b96487",
                    "#cc7c9c",
                    "#dc97b1",
                    "#e9b4c7",
                    "#f4d1dd",
                    "#fcf0f4",
                ],
                red: [
                    "#1f0e0b",
                    "#3d1716",
                    "#5d1e1f",
                    "#7c282a",
                    "#9a3537",
                    "#b64647",
                    "#ce5c5b",
                    "#e17672",
                    "#ef938d",
                    "#f9b1ab",
                    "#ffd0cb",
                    "#ffefee",
                ],
                orange: [
                    "#211106",
                    "#3d1c0d",
                    "#5b2711",
                    "#793315",
                    "#96401b",
                    "#b15024",
                    "#c96232",
                    "#e07b4a",
                    "#f1986a",
                    "#fcb590",
                    "#ffd4bc",
                    "#fff2eb",
                ],
                yellow: [
                    "#131007",
                    "#252011",
                    "#383016",
                    "#4b421b",
                    "#605420",
                    "#7b6c26",
                    "#a59433",
                    "#cdba4d",
                    "#e6d370",
                    "#f4e296",
                    "#fcefc2",
                    "#fefaef",
                ],
                green: [
                    "#10180a",
                    "#1a2a15",
                    "#223e1e",
                    "#2b5329",
                    "#346735",
                    "#407c43",
                    "#509054",
                    "#69a76a",
                    "#89bd86",
                    "#acd1a5",
                    "#cfe5c7",
                    "#f1f8ed",
                ],
                teal: [
                    "#060b09",
                    "#14201c",
                    "#1c342c",
                    "#24493d",
                    "#2d5d4f",
                    "#377261",
                    "#438572",
                    "#519883",
                    "#6db29e",
                    "#94cdbc",
                    "#bfe3d7",
                    "#eaf6f2",
                ],
                modes: {
                    default: {
                        background: "#ffffff",
                        text: "#1a2a15",
                        border: "#c7c7c7",
                        primary: "#a24f72",
                        accent: "#3c4f8a",
                        muted: "#131007",
                    },
                    dark: {
                        background: "#0d0d0d",
                        text: "#f3f3f3",
                        border: "#f2f3f3",
                        primary: "#14201c",
                        accent: "#605420",
                        muted: "#3e4145",
                    },
                },
            },
            fontSizes: [],
            borderStyles: [],
            lineHeights: {},
            space: [],
            name: "Color System - LCH (B-Spline)",
            fonts: {},
            description: "132 colors\n5,252 Accessible combos\nEach color has an accessible match within the scale",
            borderRadius: [],
            text: {},
        },
        monotone: {
            name: "Color System - LCH (Monotone)",
            colors: {
                gray: [
                    "#000000",
                    "#1a1a1a",
                    "#2c2c2c",
                    "#404040",
                    "#555555",
                    "#6b6b6b",
                    "#828282",
                    "#999999",
                    "#b2b2b2",
                    "#cbcbcb",
                    "#e5e5e5", 
                    "#ffffff",
                ],
                "slate-gray": [
                    "#0e0e0f",
                    "#1f2023", 
                    "#303137",
                    "#42434d",
                    "#555762",
                    "#696b78",
                    "#7e808e",
                    "#9496a3",
                    "#acadb8",
                    "#c4c5cd",
                    "#dddde2",
                    "#f6f6f7",
                ],
                blue: [
                    "#11151b",
                    "#192634",
                    "#1f374f",
                    "#264a6b",
                    "#305d86",
                    "#40719f",
                    "#5885b4",
                    "#749ac5",
                    "#92b0d3",
                    "#b2c6e0",
                    "#d1dceb",
                    "#f0f3f8",
                ],
                indigo: [
                    "#0f1016",
                    "#1c202f",
                    "#28304b",
                    "#344269",
                    "#425485",
                    "#5467a0",
                    "#6a7cb6",
                    "#8392c7",
                    "#9ea9d6",
                    "#bac1e1",
                    "#d6daed",
                    "#f2f3f8",
                ],
                violet: [
                    "#130f15",
                    "#261d2d",
                    "#3a2b48",
                    "#4f3963",
                    "#65497f",
                    "#7a5b98",
                    "#9070ae",
                    "#a587c0",
                    "#baa0cf",
                    "#cdbbdd",
                    "#e1d6ea",
                    "#f5f2f8",
                ],
                magenta: [
                    "#160e14",
                    "#2e1a29",
                    "#48253f",
                    "#633057",
                    "#7e3e6f",
                    "#984e86",
                    "#ae639c",
                    "#c17daf",
                    "#d198c2",
                    "#dfb5d3",
                    "#ecd3e4",
                    "#f8f1f6",
                ],
                red: [
                    "#190e0d",
                    "#341b1b",
                    "#542626",
                    "#743233",
                    "#934041",
                    "#b05152",
                    "#c86766",
                    "#da807d",
                    "#e79b98",
                    "#efb8b4",
                    "#f6d5d2",
                    "#fcf1f1",
                ],
                orange: [
                    "#140805",
                    "#2f1813",
                    "#4d251b",
                    "#6e3221",
                    "#8e4126",
                    "#ac512b",
                    "#c76232",
                    "#dd763e",
                    "#f4975f",
                    "#fdb68a",
                    "#fed5bc",
                    "#fff4ed",
                ],
                yellow: [
                    "#181308",
                    "#2d2411",
                    "#433615",
                    "#5b4919",
                    "#735c1c",
                    "#8a6f1f",
                    "#ac8c26",
                    "#d4af31",
                    "#f5cc44",
                    "#ffde70",
                    "#ffebb0",
                    "#fff9ee",
                ],
                green: [
                    "#0c120a",
                    "#182415",
                    "#20371c",
                    "#294a23",
                    "#355f2d",
                    "#44743b",
                    "#59894f",
                    "#739e69",
                    "#91b487",
                    "#b0c9a8",
                    "#d0decb",
                    "#f0f4ee",
                ],
                teal: [
                    "#0d1311",
                    "#192420",
                    "#223730",
                    "#2b4a40",
                    "#375f52",
                    "#477365",
                    "#5c8879",
                    "#759e90",
                    "#92b3a7",
                    "#b1c8c0",
                    "#d0ded9",
                    "#f0f4f2",
                ],
                cyan: [
                    "#0d1314",
                    "#162527",
                    "#1d383c",
                    "#234c51",
                    "#2d6067",
                    "#3c757d",
                    "#528a92",
                    "#6e9fa7",
                    "#8cb4ba",
                    "#adc9cd",
                    "#cfdfe1",
                    "#eff4f5",
                ],
                modes: {
                    "alt-0": {
                        background: "#f5f2f8",
                        text: "#130f15",
                        border: "#f5f2f8",
                        primary: "#baa0cf",
                        accent: "#7e3e6f",
                        muted: "#3a2b48",
                    },
                    "alt-1": {
                        background: "#160e14",
                        text: "#f8f1f6",
                        border: "#160e14",
                        primary: "#f4975f",
                        accent: "#b1c8c0",
                        muted: "#d198c2",
                    },
                    "alt-2": {
                        background: "#0c120a",
                        text: "#f0f4ee",
                        border: "#0c120a",
                        primary: "#d4af31",
                        accent: "#59894f",
                        muted: "#d0decb",
                    },
                    "alt-3": {
                        background: "#f0f4f2",
                        text: "#0d1311",
                        border: "#f0f4f2",
                        primary: "#555555",
                        accent: "#433615",
                        muted: "#375f52",
                    },
                    "default-2": {
                        background: "#ffffff",
                        text: "#000000",
                        border: "#cbcbcb",
                        primary: "#425485",
                        accent: "#d6daed",
                        muted: "#6b6b6b",
                    },
                    "dark-alt": {
                        background: "#000000",
                        text: "#ffffff",
                        border: "#404040",
                        primary: "#6a7cb6",
                        accent: "#28304b",
                        muted: "#828282",
                    },
                    "dim-light": {
                        background: "#cbcbcb",
                        text: "#2c2c2c",
                        border: "#b2b2b2",
                        primary: "#2c2c2c",
                        accent: "#b2b2b2",
                        muted: "#555555",
                    },
                    "dim-dark": {
                        background: "#2c2c2c",
                        text: "#cbcbcb",
                        border: "#fff9ee",
                        primary: "#b2b2b2",
                        accent: "#555555",
                        muted: "#b2b2b2",
                    },
                    blue: {
                        background: "#192634",
                        text: "#d1dceb",
                        border: "#fff9ee",
                        primary: "#f4975f",
                        accent: "#9ea9d6",
                        muted: "#749ac5",
                    },
                    "blue-alt": {
                        background: "#f0f3f8",
                        text: "#192634",
                        border: "#d1dceb",
                        primary: "#264a6b",
                        accent: "#d1dceb",
                        muted: "#1f374f",
                    },
                    indigo: {
                        background: "#28304b",
                        text: "#bac1e1",
                        border: "#0c120a",
                        primary: "#da807d",
                        accent: "#f2f3f8",
                        muted: "#9ea9d6",
                    },
                    "indigo-alt": {
                        background: "#d6daed",
                        text: "#28304b",
                        border: "#f8f1f6",
                        primary: "#344269",
                        accent: "#bac1e1",
                        muted: "#344269",
                    },

                    "default-alt": {
                        background: "#ffffff",
                        text: "#000000",
                        border: "#cbcbcb",
                        primary: "#425485",
                        accent: "#d6daed",
                        muted: "#6b6b6b",
                    },

                    "indigo-alt-1": {
                        background: "#d6daed",
                        text: "#28304b",
                        border: "#f8f1f6",
                        primary: "#344269",
                        accent: "#bac1e1",
                        muted: "#344269",
                    },
                    purple: {
                        background: "#f5f2f8",
                        text: "#130f15",
                        border: "#f5f2f8",
                        primary: "#baa0cf",
                        accent: "#7e3e6f",
                        muted: "#3a2b48",
                    },
                    "dark-alt-3": {
                        background: "#160e14",
                        text: "#f8f1f6",
                        border: "#160e14",
                        primary: "#f4975f",
                        accent: "#b1c8c0",
                        muted: "#d198c2",
                    },
                    "dark-alt-2": {
                        background: "#0c120a",
                        text: "#f0f4ee",
                        border: "#0c120a",
                        primary: "#d4af31",
                        accent: "#59894f",
                        muted: "#d0decb",
                    },
                    "light-alt-1": {
                        background: "#f0f4f2",
                        text: "#0d1311",
                        border: "#f0f4f2",
                        primary: "#555555",
                        accent: "#4d251b",
                        muted: "#375f52",
                    },
                    "light-alt-2": {
                        background: "#dddde2",
                        text: "#162527",
                        border: "#b2b2b2",
                        primary: "#2b4a40",
                        accent: "#b05152",
                        muted: "#696b78",
                    },
                    sea: {
                        background: "#6e9fa7",
                        text: "#162527",
                        border: "#6e9fa7",
                        primary: "#181308",
                        accent: "#000000",
                        muted: "#2c2c2c",
                    },
                    yellow: {
                        background: "#f5cc44",
                        text: "#181308",
                        border: "#181308",
                        primary: "#42434d",
                        accent: "#294a23",
                        muted: "#404040",
                    },
                    "dark-alt-1": {
                        background: "#11151b",
                        text: "#dddde2",
                        border: "#264a6b",
                        primary: "#234c51",
                        accent: "#528a92",
                        muted: "#2b4a40",
                    },
                    lightAlt8: {
                        background: "#e5e5e5",
                        text: "#0e0e0f",
                        border: "#828282",
                        primary: "#b1c8c0",
                        accent: "#234c51",
                        muted: "#1f374f",
                    },
                    slates: {
                        background: "#9496a3",
                        text: "#1f2023",
                        border: "#1f2023",
                        primary: "#fff9ee",
                        accent: "#162527",
                        muted: "#2e1a29",
                    },
                    green: {
                        background: "#759e90",
                        text: "#192420",
                        border: "#192420",
                        primary: "#e79b98",
                        accent: "#000000",
                        muted: "#341b1b",
                    },


                },
            },
            fonts: {},
            description: "156 colors\n\n7,256 accessible color combos",
            breakpoints: [],
            borderWidths: [],
            space: [],
            lineHeights: {},
            fontSizes: [],
            borderRadius: [],
            borderStyles: [],
            gradients: {},
            text: {},
        }

    }
}
export default colorSystems;